/**
 * Settings set utilities - extracted to break circular dependency
 * between docGetEntitySettings.ts and docGetSettingsSets.ts
 */
import type { Doc } from "building-types/doc";
import type { SettingsSetHandle } from "building-types/handles/docEntityHandleTypes";
import type { SettingsFragment } from "building-types/settings/settingsFragment";
import { docEntityGetChildrenFromTable } from "./entity/docEntityGetChildrenFromTable";
import { sortSettingsByFormattedType } from "./settingsTools";

export function docGetSettingSetSettings(doc: Pick<Doc, "settings">, handle: SettingsSetHandle): SettingsFragment[] {
  const settings = docEntityGetChildrenFromTable(doc.settings, handle.id);
  return sortSettingsByFormattedType(Object.values(settings));
}
